var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1Img(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 338,
    viewBox: "0 0 416 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0552 142.742V142.717L14.0527 142.692C14.0446 142.611 14.0536 142.529 14.0791 142.452C14.1046 142.374 14.1461 142.303 14.2008 142.243C14.2556 142.183 14.3223 142.134 14.3967 142.102C14.4647 142.072 14.5376 142.055 14.6117 142.053C14.7746 142.073 14.9254 142.151 15.0363 142.273C15.1522 142.401 15.2161 142.567 15.2154 142.74H15.2154V142.742V147.042C15.1977 147.197 15.1282 147.341 15.0182 147.451C14.909 147.561 14.7665 147.63 14.6139 147.648C14.468 147.643 14.3291 147.582 14.2253 147.478C14.1165 147.369 14.0552 147.222 14.0552 147.067V142.742Z",
    fill: "url(#paint0_linear_87_155)",
    stroke: "url(#paint1_linear_87_155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8951 144.905V144.88L11.8926 144.855C11.8844 144.774 11.8934 144.692 11.9189 144.614C11.9445 144.537 11.986 144.466 12.0407 144.405C12.0954 144.345 12.1622 144.297 12.2366 144.264C12.311 144.232 12.3914 144.215 12.4727 144.215V144.215H12.4752H16.7696C16.9335 144.235 17.0851 144.313 17.1965 144.436C17.3077 144.558 17.3711 144.717 17.3754 144.882C17.3573 145.036 17.288 145.179 17.1784 145.289C17.0684 145.399 16.9247 145.468 16.7707 145.486H12.4752C12.3215 145.486 12.174 145.425 12.0652 145.316C11.9563 145.207 11.8951 145.059 11.8951 144.905Z",
    fill: "url(#paint2_linear_87_155)",
    stroke: "url(#paint3_linear_87_155)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2354 163.878C40.0949 164.06 39.9071 164.197 39.694 164.277C39.481 164.197 39.2932 164.06 39.1527 163.878C38.9854 163.663 38.8945 163.397 38.8945 163.124C38.8945 162.851 38.9854 162.585 39.1527 162.37C39.2932 162.188 39.481 162.051 39.694 161.971C39.9071 162.051 40.0949 162.188 40.2354 162.37C40.4027 162.585 40.4935 162.851 40.4935 163.124C40.4935 163.397 40.4027 163.663 40.2354 163.878Z",
    fill: "url(#paint4_linear_87_155)",
    stroke: "url(#paint5_linear_87_155)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M338.125 46.2532H338.15L338.175 46.2507C338.256 46.2425 338.338 46.2515 338.415 46.277C338.492 46.3025 338.563 46.344 338.623 46.3987C338.683 46.4534 338.731 46.5203 338.764 46.595L339.222 46.3941L338.764 46.595C338.797 46.6697 338.814 46.7504 338.813 46.8319H338.813V46.8344V51.1336C338.793 51.2981 338.715 51.4501 338.593 51.5616C338.47 51.6729 338.312 51.7362 338.148 51.7405C337.995 51.7224 337.852 51.6531 337.742 51.5435C337.632 51.4334 337.563 51.2893 337.545 51.1347V46.8344C337.545 46.6801 337.606 46.5322 337.715 46.4232C337.824 46.3143 337.971 46.2532 338.125 46.2532ZM339.313 46.8344V51.1595C339.286 51.4558 339.149 51.7312 338.929 51.9314C338.709 52.1316 338.422 52.242 338.125 52.2407L339.313 46.8344Z",
    fill: "url(#paint6_linear_87_155)",
    stroke: "url(#paint7_linear_87_155)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M340.287 49.5782V49.5782H340.285H335.99C335.836 49.5605 335.692 49.4911 335.582 49.381C335.473 49.2717 335.404 49.1288 335.385 48.9756C335.391 48.829 335.451 48.6897 335.555 48.5858C335.664 48.4768 335.811 48.4157 335.965 48.4157H340.285H340.31L340.335 48.4132C340.416 48.4051 340.498 48.414 340.575 48.4395C340.652 48.465 340.723 48.5065 340.783 48.5612L341.12 48.1915L340.783 48.5612C340.843 48.616 340.891 48.6828 340.924 48.7575C340.954 48.8258 340.971 48.899 340.973 48.9734C340.953 49.1369 340.875 49.2881 340.753 49.3991C340.625 49.5151 340.459 49.5789 340.287 49.5782ZM340.285 50.0782H335.965H340.285Z",
    fill: "url(#paint8_linear_87_155)",
    stroke: "url(#paint9_linear_87_155)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1302 19.5217L61.1052 19.5192H61.0801C60.9264 19.5192 60.7789 19.4581 60.6701 19.3491C60.5612 19.2401 60.5 19.0922 60.5 18.9379V14.6129C60.5 14.4585 60.5612 14.3106 60.6701 14.2017C60.7789 14.0927 60.9264 14.0316 61.0801 14.0316H61.1052L61.1302 14.0291C61.211 14.021 61.2926 14.0299 61.3698 14.0554C61.447 14.0809 61.518 14.1224 61.5781 14.1772L61.9147 13.8074L61.5781 14.1772C61.6383 14.2319 61.6864 14.2988 61.7191 14.3734L62.177 14.1725L61.7191 14.3734C61.7519 14.4481 61.7686 14.5288 61.7682 14.6104H61.7682V14.6129L61.7682 18.9379L61.7682 18.9404C61.7686 19.022 61.7519 19.1027 61.7191 19.1773L62.177 19.3783L61.7191 19.1773C61.6864 19.252 61.6383 19.3188 61.5781 19.3736C61.5179 19.4284 61.4469 19.4698 61.3698 19.4953C61.2926 19.5208 61.211 19.5298 61.1302 19.5217Z",
    fill: "url(#paint10_linear_87_155)",
    stroke: "url(#paint11_linear_87_155)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2403 17.3567H58.9199C58.7663 17.3567 58.6188 17.2956 58.5099 17.1866C58.4011 17.0777 58.3398 16.9297 58.3398 16.7754C58.3398 16.6211 58.4011 16.4732 58.5099 16.3642C58.6188 16.2553 58.7663 16.1942 58.9199 16.1942H63.2403C63.394 16.1942 63.5415 16.2553 63.6503 16.3642C63.7592 16.4732 63.8204 16.6211 63.8204 16.7754C63.8204 16.9297 63.7592 17.0777 63.6503 17.1866C63.5415 17.2956 63.394 17.3567 63.2403 17.3567Z",
    fill: "url(#paint12_linear_87_155)",
    stroke: "url(#paint13_linear_87_155)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387.77 148.259H387.77V148.257V143.956C387.787 143.802 387.857 143.658 387.967 143.547C388.076 143.438 388.219 143.369 388.373 143.35C388.537 143.355 388.695 143.418 388.817 143.529C388.94 143.641 389.018 143.793 389.038 143.957V148.257C389.038 148.44 388.965 148.615 388.836 148.744C388.712 148.868 388.547 148.94 388.372 148.946C388.21 148.925 388.059 148.847 387.949 148.725C387.833 148.598 387.769 148.431 387.77 148.259Z",
    fill: "url(#paint14_linear_87_155)",
    stroke: "url(#paint15_linear_87_155)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M390.51 145.513L390.512 145.513C390.684 145.512 390.85 145.576 390.977 145.692C391.099 145.803 391.177 145.954 391.198 146.117C391.192 146.292 391.12 146.458 390.996 146.582L391.35 146.935L390.996 146.582C390.867 146.711 390.692 146.783 390.51 146.783H386.215C386.052 146.764 385.9 146.686 385.789 146.563C385.677 146.44 385.614 146.282 385.61 146.117C385.628 145.963 385.697 145.82 385.807 145.71C385.917 145.6 386.06 145.531 386.214 145.513L390.51 145.513Z",
    fill: "url(#paint16_linear_87_155)",
    stroke: "url(#paint17_linear_87_155)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M341.473 297.727H341.448L341.423 297.73C341.342 297.738 341.261 297.729 341.184 297.704C341.106 297.678 341.035 297.637 340.975 297.582C340.915 297.527 340.867 297.46 340.834 297.385C340.801 297.311 340.785 297.23 340.785 297.149H340.785V297.146V292.821H340.785L340.785 292.819C340.785 292.737 340.801 292.656 340.834 292.582C340.867 292.507 340.915 292.44 340.975 292.385C341.035 292.331 341.106 292.289 341.184 292.264C341.261 292.238 341.342 292.229 341.423 292.237L341.448 292.24H341.473C341.627 292.24 341.774 292.301 341.883 292.41C341.992 292.519 342.053 292.667 342.053 292.821V297.146C342.053 297.3 341.992 297.448 341.883 297.557C341.774 297.666 341.627 297.727 341.473 297.727Z",
    fill: "url(#paint18_linear_87_155)",
    stroke: "url(#paint19_linear_87_155)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343.633 295.565H339.313C339.159 295.565 339.011 295.504 338.903 295.395C338.794 295.286 338.732 295.138 338.732 294.983C338.732 294.829 338.794 294.681 338.903 294.572C339.011 294.463 339.159 294.402 339.313 294.402H343.633C343.787 294.402 343.934 294.463 344.043 294.572C344.152 294.681 344.213 294.829 344.213 294.983C344.213 295.138 344.152 295.286 344.043 295.395C343.934 295.504 343.787 295.565 343.633 295.565Z",
    fill: "url(#paint20_linear_87_155)",
    stroke: "url(#paint21_linear_87_155)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M305.507 36.2897C305.352 36.489 305.141 36.6354 304.901 36.7099C304.54 36.6948 304.304 36.5524 304.15 36.3676C303.977 36.1602 303.881 35.8636 303.886 35.5433C303.891 35.2231 303.998 34.9198 304.178 34.7054C304.34 34.5137 304.573 34.3765 304.902 34.3608C305.141 34.4354 305.353 34.5817 305.507 34.7808C305.674 34.9966 305.765 35.262 305.765 35.5353C305.765 35.8085 305.674 36.0739 305.507 36.2897Z",
    fill: "url(#paint22_linear_87_155)",
    stroke: "url(#paint23_linear_87_155)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M372.581 166.365C372.427 166.564 372.216 166.711 371.976 166.785C371.65 166.77 371.426 166.634 371.273 166.447C371.101 166.236 371.001 165.934 371.001 165.611C371.001 165.287 371.101 164.986 371.273 164.775C371.426 164.588 371.65 164.452 371.976 164.436C372.216 164.511 372.427 164.657 372.581 164.856C372.749 165.072 372.84 165.338 372.84 165.611C372.84 165.884 372.749 166.149 372.581 166.365Z",
    fill: "url(#paint24_linear_87_155)",
    stroke: "url(#paint25_linear_87_155)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7366 1.47805C80.891 1.27893 81.1024 1.1326 81.3417 1.05802C81.6686 1.07362 81.8925 1.20957 82.045 1.39644C82.2172 1.60733 82.3172 1.90912 82.3172 2.23247C82.3172 2.55582 82.2172 2.85761 82.045 3.0685C81.8925 3.25537 81.6686 3.39132 81.3417 3.40692C81.1024 3.33234 80.891 3.18601 80.7366 2.98689C80.5694 2.77115 80.4785 2.50573 80.4785 2.23247C80.4785 1.95921 80.5694 1.69379 80.7366 1.47805Z",
    fill: "url(#paint26_linear_87_155)",
    stroke: "url(#paint27_linear_87_155)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M370.205 279.897C370.065 280.079 369.877 280.216 369.664 280.296C369.451 280.216 369.263 280.079 369.122 279.897C368.955 279.682 368.864 279.416 368.864 279.143C368.864 278.87 368.955 278.604 369.122 278.389C369.263 278.207 369.451 278.07 369.664 277.99C369.877 278.07 370.065 278.207 370.205 278.389C370.372 278.604 370.463 278.87 370.463 279.143C370.463 279.416 370.372 279.682 370.205 279.897Z",
    fill: "url(#paint28_linear_87_155)",
    stroke: "url(#paint29_linear_87_155)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216.664 25.2524L216.639 25.2499H216.614C216.461 25.2499 216.313 25.1888 216.204 25.0798C216.095 24.9709 216.034 24.823 216.034 24.6686V20.3436C216.034 20.1892 216.095 20.0413 216.204 19.9324C216.313 19.8234 216.461 19.7623 216.614 19.7623H216.639L216.664 19.7598C216.745 19.7517 216.827 19.7606 216.904 19.7861C216.981 19.8116 217.052 19.8531 217.112 19.9079C217.173 19.9627 217.221 20.0295 217.253 20.1042C217.286 20.1788 217.303 20.2595 217.302 20.3411H217.302V20.3436L217.302 24.6686L217.302 24.6711C217.303 24.7527 217.286 24.8334 217.253 24.908C217.221 24.9827 217.173 25.0495 217.112 25.1043C217.052 25.1591 216.981 25.2006 216.904 25.2261C216.827 25.2516 216.745 25.2605 216.664 25.2524Z",
    fill: "url(#paint30_linear_87_155)",
    stroke: "url(#paint31_linear_87_155)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.775 23.0873H214.454C214.3 23.0873 214.153 23.0262 214.044 22.9173C213.935 22.8083 213.874 22.6604 213.874 22.5061C213.874 22.3517 213.935 22.2038 214.044 22.0949C214.153 21.9859 214.3 21.9248 214.454 21.9248H218.775C218.928 21.9248 219.076 21.9859 219.185 22.0949C219.293 22.2038 219.355 22.3517 219.355 22.5061C219.355 22.6604 219.293 22.8083 219.185 22.9173C219.076 23.0262 218.928 23.0873 218.775 23.0873Z",
    fill: "url(#paint32_linear_87_155)",
    stroke: "url(#paint33_linear_87_155)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M244.371 5.91122C244.526 5.7121 244.737 5.56576 244.976 5.49118C245.303 5.50679 245.527 5.64273 245.68 5.82961C245.852 6.0405 245.952 6.34228 245.952 6.66564C245.952 6.98899 245.852 7.29077 245.68 7.50167C245.527 7.68854 245.303 7.82449 244.976 7.84009C244.737 7.76551 244.526 7.61917 244.371 7.42005C244.204 7.20432 244.113 6.93889 244.113 6.66563C244.113 6.39237 244.204 6.12696 244.371 5.91122Z",
    fill: "url(#paint34_linear_87_155)",
    stroke: "url(#paint35_linear_87_155)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358.389 119.166C358.606 119.297 358.794 119.471 358.943 119.676C359.091 119.882 359.196 120.115 359.252 120.363C359.308 120.61 359.313 120.866 359.267 121.116C359.222 121.365 359.126 121.603 358.986 121.814C358.783 122.121 358.495 122.361 358.156 122.505C357.818 122.649 357.445 122.691 357.084 122.624C356.722 122.558 356.388 122.387 356.123 122.132L355.845 122.421L356.123 122.132C355.858 121.877 355.673 121.55 355.592 121.19C355.511 120.831 355.537 120.456 355.667 120.112C355.797 119.767 356.026 119.469 356.324 119.253C356.622 119.038 356.976 118.915 357.343 118.899C357.711 118.884 358.074 118.977 358.389 119.166Z",
    fill: "url(#paint36_linear_87_155)",
    stroke: "url(#paint37_linear_87_155)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.854 9.42285H170.818",
    stroke: "url(#paint38_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.127 69.5409H405.091",
    stroke: "url(#paint39_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M202.465 48.9969H222.123",
    stroke: "url(#paint40_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M395.262 170.314H414.919",
    stroke: "url(#paint41_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M168.226 336.396H187.883",
    stroke: "url(#paint42_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.366 322.556H241.024",
    stroke: "url(#paint43_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4854 208.591H51.1431",
    stroke: "url(#paint44_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35059 196.697H41.3142",
    stroke: "url(#paint45_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.409 336.396H155.373",
    stroke: "url(#paint46_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.934 322.556H291.897",
    stroke: "url(#paint47_linear_87_155)",
    strokeWidth: 1.98,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M312.094 70.9465H95.8587C86.9109 70.9465 79.6572 78.208 79.6572 87.1654V223.793C79.6572 232.751 86.9109 240.012 95.8587 240.012H312.094C321.042 240.012 328.296 232.751 328.296 223.793V87.1654C328.296 78.208 321.042 70.9465 312.094 70.9465Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M302.806 90.301H105.148C101.449 90.301 98.4512 93.3024 98.4512 97.0048V214.138C98.4512 217.84 101.449 220.841 105.148 220.841H302.806C306.504 220.841 309.502 217.84 309.502 214.138V97.0048C309.502 93.3024 306.504 90.301 302.806 90.301Z",
    fill: "white",
    stroke: "#2A2A2A",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M252.581 288.28H155.372L168.225 240.056H239.728L252.581 288.28Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.495 248.165L236.92 280.17H170.926L179.458 248.165H228.495ZM229.251 247.084H178.594L169.521 281.252H238.324L229.251 247.084Z",
    fill: "#2A2A2A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M265.758 301.687H142.195C142.195 298.15 143.591 294.756 146.08 292.245C148.568 289.733 151.947 288.308 155.481 288.28H252.365C255.917 288.28 259.324 289.692 261.836 292.207C264.347 294.721 265.758 298.131 265.758 301.687Z",
    stroke: "#2A2A2A",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9912 106.412H309.502",
    stroke: "#2A2A2A",
    strokeWidth: 1.98,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M110.98 99.4917C110.98 100.123 110.73 100.728 110.284 101.174C109.838 101.62 109.234 101.871 108.604 101.871C108.297 101.871 107.993 101.809 107.71 101.688C107.428 101.567 107.173 101.39 106.96 101.168C106.748 100.945 106.584 100.682 106.476 100.394C106.369 100.106 106.321 99.7989 106.336 99.4917C106.336 98.8895 106.575 98.312 107 97.8861C107.425 97.4603 108.002 97.2211 108.604 97.2211C108.911 97.2064 109.217 97.2543 109.505 97.3619C109.793 97.4694 110.056 97.6343 110.278 97.8467C110.5 98.059 110.677 98.3143 110.798 98.5971C110.918 98.8799 110.98 99.1842 110.98 99.4917Z",
    fill: "#2A2A2A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.565 99.4917C121.58 99.7989 121.532 100.106 121.425 100.394C121.317 100.682 121.152 100.945 120.94 101.168C120.728 101.39 120.473 101.567 120.191 101.688C119.908 101.809 119.604 101.871 119.297 101.871C118.667 101.871 118.063 101.62 117.617 101.174C117.171 100.728 116.921 100.123 116.921 99.4917C116.921 99.1842 116.983 98.8799 117.103 98.5971C117.224 98.3143 117.401 98.059 117.623 97.8467C117.845 97.6343 118.108 97.4694 118.396 97.3619C118.684 97.2543 118.99 97.2064 119.297 97.2211C119.899 97.2211 120.476 97.4603 120.901 97.8861C121.326 98.312 121.565 98.8895 121.565 99.4917Z",
    fill: "#2A2A2A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M133.123 99.4918C133.123 100.123 132.872 100.728 132.427 101.174C131.981 101.62 131.377 101.871 130.746 101.871C130.116 101.871 129.512 101.62 129.066 101.174C128.62 100.728 128.37 100.123 128.37 99.4918C128.37 98.8609 128.62 98.2559 129.066 97.8098C129.512 97.3637 130.116 97.113 130.746 97.113C131.377 97.113 131.981 97.3637 132.427 97.8098C132.872 98.2559 133.123 98.8609 133.123 99.4918Z",
    fill: "#2A2A2A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.155 97.7617H149.85C148.903 97.7617 148.136 98.529 148.136 99.4755C148.136 100.422 148.903 101.189 149.85 101.189H291.155C292.101 101.189 292.869 100.422 292.869 99.4755C292.869 98.529 292.101 97.7617 291.155 97.7617Z",
    fill: "#2A2A2A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M165.742 117.008H111.413V153.663H165.742V117.008Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M162.178 121.333H114.653V125.658H162.178V121.333Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.374 133.227H114.653V142.958H124.374V133.227Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M142.736 133.227H133.015V142.958H142.736V133.227Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M161.098 133.227H151.377V142.958H161.098V133.227Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.742 167.827H111.413V204.482H165.742V167.827Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M231.952 117.008H177.623V153.663H231.952V117.008Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M231.952 167.827H177.623V204.482H231.952V167.827Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M298.161 117.008H243.832V153.663H298.161V117.008Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M298.161 167.827H243.832V204.482H298.161V167.827Z",
    fill: "#2A2A2A",
    fillOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_155",
    x1: 13.5047,
    y1: 141.311,
    x2: 17.0801,
    y2: 141.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_155",
    x1: 13.5047,
    y1: 141.311,
    x2: 17.0801,
    y2: 141.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_155",
    x1: 11.2545,
    y1: 143.632,
    x2: 16.3257,
    y2: 149.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_155",
    x1: 11.2545,
    y1: 143.632,
    x2: 16.3257,
    y2: 149.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_87_155",
    x1: 38.3404,
    y1: 161.325,
    x2: 42.3577,
    y2: 162.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_87_155",
    x1: 38.3404,
    y1: 161.325,
    x2: 42.3577,
    y2: 162.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_87_155",
    x1: 336.998,
    y1: 45.51,
    x2: 340.735,
    y2: 45.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_87_155",
    x1: 336.998,
    y1: 45.51,
    x2: 340.735,
    y2: 45.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_87_155",
    x1: 334.748,
    y1: 47.8309,
    x2: 339.56,
    y2: 53.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_87_155",
    x1: 334.748,
    y1: 47.8309,
    x2: 339.56,
    y2: 53.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_87_155",
    x1: 59.9527,
    y1: 13.2883,
    x2: 63.6903,
    y2: 13.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_87_155",
    x1: 59.9527,
    y1: 13.2883,
    x2: 63.6903,
    y2: 13.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_87_155",
    x1: 57.7048,
    y1: 15.615,
    x2: 62.5135,
    y2: 21.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_87_155",
    x1: 57.7048,
    y1: 15.615,
    x2: 62.5135,
    y2: 21.0098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_87_155",
    x1: 387.222,
    y1: 142.609,
    x2: 390.962,
    y2: 143.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_87_155",
    x1: 387.222,
    y1: 142.609,
    x2: 390.962,
    y2: 143.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_87_155",
    x1: 384.972,
    y1: 144.93,
    x2: 390.037,
    y2: 150.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_87_155",
    x1: 384.972,
    y1: 144.93,
    x2: 390.037,
    y2: 150.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_87_155",
    x1: 340.238,
    y1: 291.496,
    x2: 343.976,
    y2: 291.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_87_155",
    x1: 340.238,
    y1: 291.496,
    x2: 343.976,
    y2: 291.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_87_155",
    x1: 338.097,
    y1: 293.823,
    x2: 342.906,
    y2: 299.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_87_155",
    x1: 338.097,
    y1: 293.823,
    x2: 342.906,
    y2: 299.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_87_155",
    x1: 303.326,
    y1: 33.7366,
    x2: 307.699,
    y2: 35.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_87_155",
    x1: 303.326,
    y1: 33.7366,
    x2: 307.699,
    y2: 35.1431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_87_155",
    x1: 370.442,
    y1: 163.812,
    x2: 374.765,
    y2: 165.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_87_155",
    x1: 370.442,
    y1: 163.812,
    x2: 374.765,
    y2: 165.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_87_155",
    x1: 79.9194,
    y1: 0.433798,
    x2: 84.2423,
    y2: 1.80434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_87_155",
    x1: 79.9194,
    y1: 0.433798,
    x2: 84.2423,
    y2: 1.80434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_87_155",
    x1: 368.31,
    y1: 277.344,
    x2: 372.327,
    y2: 278.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_87_155",
    x1: 368.31,
    y1: 277.344,
    x2: 372.327,
    y2: 278.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_87_155",
    x1: 215.487,
    y1: 19.019,
    x2: 219.225,
    y2: 19.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_87_155",
    x1: 215.487,
    y1: 19.019,
    x2: 219.225,
    y2: 19.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_87_155",
    x1: 213.239,
    y1: 21.3456,
    x2: 218.048,
    y2: 26.7405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_87_155",
    x1: 213.239,
    y1: 21.3456,
    x2: 218.048,
    y2: 26.7405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_87_155",
    x1: 243.554,
    y1: 4.86696,
    x2: 247.877,
    y2: 6.23752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_87_155",
    x1: 243.554,
    y1: 4.86696,
    x2: 247.877,
    y2: 6.23752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_87_155",
    x1: 354.947,
    y1: 118.224,
    x2: 361.935,
    y2: 120.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_87_155",
    x1: 354.947,
    y1: 118.224,
    x2: 361.935,
    y2: 120.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_87_155",
    x1: 130.022,
    y1: 9.38624,
    x2: 130.32,
    y2: 13.8431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_87_155",
    x1: 364.294,
    y1: 69.5043,
    x2: 364.592,
    y2: 73.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_87_155",
    x1: 202.055,
    y1: 48.9603,
    x2: 202.653,
    y2: 53.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_87_155",
    x1: 394.852,
    y1: 170.278,
    x2: 395.449,
    y2: 174.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_87_155",
    x1: 167.816,
    y1: 336.359,
    x2: 168.413,
    y2: 340.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_87_155",
    x1: 220.957,
    y1: 322.519,
    x2: 221.554,
    y2: 326.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_87_155",
    x1: 31.0758,
    y1: 208.554,
    x2: 31.6731,
    y2: 212.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_87_155",
    x1: 0.518013,
    y1: 196.66,
    x2: 0.815907,
    y2: 201.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_87_155",
    x1: 114.577,
    y1: 336.359,
    x2: 114.875,
    y2: 340.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_87_155",
    x1: 251.101,
    y1: 322.519,
    x2: 251.399,
    y2: 326.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A6FE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2FF2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1Img);
export default __webpack_public_path__ + "static/media/step1_img.edd9a53e7b2032d0cec4d4d7043b9911.svg";
export { ForwardRef as ReactComponent };